import React from 'react'

import {Box} from '@mui/material'

import CenteredContainer from '@progyny/components/CenteredContainer'
import ActionButtonsContainer from '@progyny/components/SimpleMessageContainer/ActionButtonsContainer'

export type SimpleMessageContainerProps = {
  message: React.ReactNode
  image?: React.ComponentType<any>
  actionArea?: React.ReactNode
  CustomImage?: React.ReactNode
  justfyContent?: 'start' | 'center' | 'end'
}

const SimpleMessageContainer = ({
  message,
  image: Image,
  actionArea,
  CustomImage,
  justfyContent,
}: SimpleMessageContainerProps) => {
  return (
    <CenteredContainer>
      <Box
        maxWidth={420}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: 'calc(100vh - 56px - 64px)',
        }}
      >
        {!CustomImage && Image ? (
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            mb={3}
          >
            <Image />
          </Box>
        ) : (
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            mb={3}
          >
            {CustomImage}
          </Box>
        )}
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
          {message}
          <ActionButtonsContainer>{actionArea}</ActionButtonsContainer>
        </Box>
      </Box>
    </CenteredContainer>
  )
}

export default SimpleMessageContainer
